module.exports = __webpack_public_path__ + "img/border-outer.52b7ecae.svg";